// @flow
import Confirmation from './Confirmation';
import useConfirmation from './useConfirmation';

export default Confirmation;
export { useConfirmation };
